/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
// eslint-disable-next-line
import lozad from 'lozad';

const observer = lozad('.lozad', {

    loaded: (el) => {

        // Add js loaded class once loaded
        el.classList.add('js-loaded');

    },

});

observer.observe();
